export default {
  data() {
    return {
      settings: {
        sendLabel: 'login',
      },
      groups: {
        login: {
          visible: true,
          fields: {
            username: {
              type: 'text',
              model: null,
              placeholder: 'E-mail',
              label: 'username_email',
              rules: 'required',
            },
            password: {
              type: 'password',
              model: null,
              placeholder: 'Password',
              label: 'password',
              // rules: 'required',
            },
          },
        },
      },
    };
  },
  methods: {
    init() {

    },
    async callback() {
      const loggedIn = await this.$store.dispatch('login', {
        username: this.groups.login.fields.username.model,
        password: this.groups.login.fields.password.model,
      });
      if (loggedIn) {
        // Attendiamo che CoCart aggiorni il Cookie del carrelo, associando l'ID all'hash casuale
        setTimeout(async () => {
          await this.$store.dispatch('loadCustomerData');

          // temp fix wc subscription
          if (this.$route.query.wcs_redirect && this.$route.query.wcs_redirect_id) {
            this.$router.push({
              name: 'PayOrder',
              params: {
                orderId: this.$route.query.wcs_redirect_id,
              },
            });
          }
        }, 2000);
      }
    },
  },
};
